import { Column } from "@tanstack/react-table";
import { ArrowUpDown } from "lucide-react";
import { PropsWithChildren } from "react";

import { Button } from "@/components/ui/button";

type Props<T> = PropsWithChildren<{
  column: Column<T, unknown>;
}>;

export const SortableHeader = <T,>({ column, children }: Props<T>) => (
  <Button
    variant="ghost"
    onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
  >
    {children}
    <ArrowUpDown className="ml-2 h-4 w-4" />
  </Button>
);
